<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT_MEASURE, constants.PERMISSION_VALUES.LIST)">
    <main-header />
    <measures-filter />
    <div v-if="!isLoading" class="spl-measures-table">
      <table>
        <thead>
          <tr class="spl-measures-table__head">
            <th v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.ADD_PROBLEM_REPORT_MEASURE)" class="spl-measures-table__head--checkbox">
              <form-checkbox
                v-model="allProblemReportsSelected"
                :checked="allProblemReportsSelected"
                @checkboxChanged="checkAllProblemReports" />
            </th>
            <th
              v-for="(header, index) in tableFields"
              :key="'dashboardPrecariageHeader' + index"
              @click="toggleSort(header.name)">
              <span
                v-if="findSort(sortedFields, header.name)"
                :class="findSort(sortedFields, header.name).direction"
                class="order-arrow" />
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(problemReport, parcelIndex) in sortedProblemReports"
            :key="'problemReportTable' + parcelIndex"
            :class="{'spl-measures-table__row--green': hasMeasure(problemReport)}">
            <td v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.ADD_PROBLEM_REPORT_MEASURE)" class="spl-measures-table__field--checkbox">
              <form-checkbox
                :checked="selectedProblemReports.indexOf(problemReport.Problem_Report_ID) !== -1"
                @checkboxChanged="checkProblemReport(problemReport)" />
            </td>
            <td
              v-for="(field, fieldIndex) in tableFields"
              :key="'dashboardPrecariageField' + parcelIndex + '.' + fieldIndex"
              :class="{'spl-measures-table__field--number': isNumber(problemReport[field.name]),
                       'spl-measures-table__field--long': field.long,
                       'spl-measures-table__field--bold': field.bold}"
              @click="openMeasureModalForProblemModal(problemReport)">
              <span>
                {{ formatField(problemReport[field.name], field.name, field.type) }}
              </span>
            </td></tr>
        </tbody>
      </table>
    </div>
    <div class="spl-measures-table__buttons">
      <form-button
        :disabled="selectedProblemReports.length === 0 || !userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.ADD_PROBLEM_REPORT_MEASURE)"
        @onClick="openActionModalForselectedProblemReports">Update Measure</form-button>
    </div>
    <add-measure-modal
      ref="addMeasureModal"
      :selected-problem-reports="selectedProblemReports"
      @onMeasureSaved="handleMeasureSaved" />
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { find, findIndex, orderBy, isNumber, pull, cloneDeep } from 'lodash'
import constants from '@/constants'
import Helpers from '@/helpers'

export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'Country', label: 'Country', type: 'String' },
        { name: 'Problem_Report_Responsible_Type', label: 'Responsible Type', type: 'String' },
        { name: 'Problem_Report_Type', label: 'Problem Type', type: 'String' },
        { name: 'Responsible_Provider', label: 'Reponsible Provider', type: 'String' },
        { name: 'Counter_Number', label: 'Counter Number', type: 'String' },
        { name: 'Forwarder_Reference', label: 'Forwarder Reference', type: 'String' },
        { name: 'Customer', label: 'Customer', type: 'String' },
        { name: 'Delivery_Name_1', label: 'Delivery Name', type: 'String' },
        { name: 'Delivery_Postal_Code', label: 'Delivery Postal Code', type: 'String' },
        { name: 'Delivery_City', label: 'Delivery City', type: 'String' },
        { name: 'Service_Level_Name', label: 'Service Level', type: 'String' },
        { name: 'Booked_Pickup_Date', label: 'Booked Pickup Date', type: 'Time' },
        { name: 'Delivery_Timestamp', label: 'Delivery Time', type: 'Time' },
        { name: 'Close_Deadline', label: 'Close Deadline', type: 'Time' },
        { name: 'Problem_Report_Measure_Name', label: 'Measure ID', type: 'String' },
        { name: 'Problem_Report_Measure_Freetext', label: 'Measure Text', type: 'String' }
      ],
      isLoading: false,
      sortedFields: [],
      selectedProblemReports: [],
      sortedProblemReports: [],
      allProblemReportsSelected: false,
      constants
    }
  },
  computed: {
    ...mapState('problemReport', ['loadedProblemReports']),
    ...mapGetters('problemReport', ['getMeasureFilter'])
  },
  created () {
    this.unsubscribeMeasureFilter = this.$store.subscribe(this.handleMeasureFilterUpdate)
  },
  beforeDestroy () {
    if (this.unsubscribeMeasureFilter) {
      this.unsubscribeMeasureFilter()
    }
  },
  methods: {
    ...mapActions('problemReport', ['loadProblemReports']),
    handleMeasureFilterUpdate (mutation) {
      if (mutation.type === 'problemReport/setMeasureFilter') {
        this.isLoading = true
        this.loadProblemReports().then(() => {
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      } else if (mutation.type === 'problemReport/setLoadedProblemReports') {
        this.sortedProblemReports = cloneDeep(this.loadedProblemReports)
        this.sortData()
      }
    },
    checkAllProblemReports (checked) {
      this.selectedProblemReports = []
      if (checked) {
        for (let i = 0; i < this.loadedProblemReports.length; i++) {
          this.selectedProblemReports.push(this.loadedProblemReports[i].Problem_Report_ID)
        }
      }
    },
    checkProblemReport (parcel) {
      if (this.selectedProblemReports.indexOf(parcel.Problem_Report_ID) !== -1) {
        pull(this.selectedProblemReports, parcel.Problem_Report_ID)
      } else {
        this.selectedProblemReports.push(parcel.Problem_Report_ID)
      }
      this.$forceUpdate()
    },

    toggleSort (field) {
      // Finds the sorted field in the array
      var sortedField = find(this.sortedFields, { field: field })
      if (sortedField) {
        // Switches to desc when asc already selected
        if (sortedField.direction === 'asc') {
          sortedField.direction = 'desc'
        } else {
          // removes the sorting when desc was selected
          this.sortedFields.splice(findIndex(this.sortedFields, { field: field }))
        }
      } else {
        // adds the field when not yet present
        this.sortedFields.push({ direction: 'asc', field: field })
      }
      this.sortData()
    },

    // Sorting the data
    sortData () {
      // Sort fields and directions seperate for lodash orderBy method
      let sortFields = []
      let sortDirections = []
      // Create the sort fields
      for (let i = 0; i < this.sortedFields.length; i++) {
        const sortElement = this.sortedFields[i]
        sortFields.push(sortElement.field)
        sortDirections.push(sortElement.direction)
      }
      // Default sorting depending on grouping
      if (sortFields.length === 0) {
        sortFields = [constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER]
        sortDirections = ['asc']
      }
      // Use the lodash orderBy method for sorting
      this.sortedProblemReports = orderBy(this.sortedProblemReports, sortFields, sortDirections)
    },

    // Special formatting for fields
    formatField (field, name, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },

    openMeasureModalForProblemModal (problemReport) {
      this.$refs.addMeasureModal.openModal([problemReport.Problem_Report_ID], problemReport.Problem_Report_Measure_ID, problemReport.Problem_Report_Measure_Freetext)
    },

    openActionModalForselectedProblemReports () {
      var problemReport = find(this.loadedProblemReports, { Problem_Report_ID: this.selectedProblemReports[0] })
      this.$refs.addMeasureModal.openModal(this.selectedProblemReports, problemReport.Problem_Report_Measure_ID, problemReport.Problem_Report_Measure_Freetext)
    },

    handleMeasureSaved () {
      this.allProblemReportsSelected = false
      this.selectedProblemReports = []
      this.$forceUpdate()
    },
    // find the right sort value for displaying arrows
    findSort (array, value) {
      return find(array, { field: value })
    },

    // including of helper since lodash not available in vue template
    isNumber (value) {
      return isNumber(value)
    },
    hasMeasure (problemReport) {
      return problemReport.Problem_Report_Measure_Freetext !== null
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-measures-table {

    &__buttons {
      background-color: $middleYellow;
      bottom: 0;
      height: 70px;
      padding: 18px $mainPadding;
      position: fixed;
      width: 100%;
      z-index: 310;
      display: flex;

      .spl-label-inline {
        margin-left: 10px;
        margin-top: 10px;
      }

      .spl-label {
          color: $darkerYellow;
      }
      .spl-button {
          background-color: $footerButtonYellow;
          color: $yellowButtonLabel;
          height: 34px;
          margin: 0 2px 0 0;
          padding: 0 10px;
      }
    }

    margin: 20px 70px;
    width: calc(100% - 138px);
    height: calc(100vh - 245px);
    overflow: auto;

    table {
      border-spacing: 0;
      table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--green {
        background-color: $successGreenBackground !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 2px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }
}
</style>
